/* ボタン */
import React from 'react';
import '../styles/button.scss'; 
import { Link } from 'react-router-dom';

const Button = ({ to, children, color = '#222222', padding = '10px 35px', className = 'slidebtn' }) => {
  const style = {
    backgroundColor: color,
    color: 'white',
    padding: padding,
    border: 'none',
    borderRadius: '37.5px',
    textAlign: 'center',
    textDecoration: 'none',
  };

  return (
    <Link to={'https://line.me/ti/p/pJXkom9PKy'} style={style} className={className}>
      <p className="slidebtn__text">{children}</p>
    </Link>
  );
}

export default Button;